import { siginResponseModel } from "../../main/signin-page/api/types";
import { useValidate } from "./api";
import { AuthState } from "./types";

export const getUserAuthCredentials = () => {
  const json = localStorage.getItem("authData");
  if (json) {
    try {
      const authData: siginResponseModel = JSON.parse(json);
      return authData;
    } catch (error) {
      console.error("Error parsing auth data:", error);
      return null;
    }
  }
  return null;
};

export const resetStorage = () => {
  localStorage.clear();
  sessionStorage.clear();
};

// useIsAuthenticated.ts
export const useIsAuthenticated = () => {
  const validate = useValidate(); // this is a mutation

  const checkAuth = async (): Promise<AuthState> => {
    return new Promise((resolve) => {
      validate.mutate(undefined, {
        onSuccess: () => resolve(AuthState.Authenticated),
        onError: () => resolve(AuthState.Unauthenticated),
      });
    });
  };

  return { checkAuth };
};
